// extracted by mini-css-extract-plugin
export default {"root":"CaretContainer-root-4deeaf6cce1508f63d9a74956bac7856","active":"CaretContainer-active-2156a3d294590b4ec23026881515431d"};